import React from "react"
import { Outlet } from "react-router-dom"
// import Foot from "../components/Foot"
// import CreatorHeader from "../components/CreatorHeader"

const Creator = () => (
  <React.Fragment>
    <div className="w-full h-screen px-1 text-gray-700 antialiased font-[inter]">
      <Outlet />
    </div>
  </React.Fragment>
)

export default Creator
